import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { IRecoverPayment } from 'types/Payment';

import { recoveryPayment } from '../../services/Api';

import RecoverPaymentButton from './RecoveryPaymentButton.styles';

export interface IRecoveryPaymentButton {
  paymentId: string;
  className: string;
  isRecoveryEnabled?: boolean;
  type?: string;
  message: string;
  onClick: () => void;
  onError: (error: Error) => void;
}

export class RecoveryPaymentButton extends PureComponent<IRecoveryPaymentButton, { className: string }> {
  constructor(props) {
    super(props);
    const { className } = this.props;
    this.state = {
      className: `${className} recovery-payment-button`,
    };
  }

  handleRecoverPayment = async () => {
    const { onClick, onError, paymentId } = this.props;

    try {
      onClick();
      const recoverPayment: IRecoverPayment = await recoveryPayment(paymentId);
      window.location.assign(recoverPayment.redirectUrl);
    } catch (e) {
      onError(e as Error);
    }
  };

  render() {
    const { isRecoveryEnabled, message, type } = this.props;
    const { className } = this.state;

    return (
      <>
        {isRecoveryEnabled && (
          <RecoverPaymentButton className={className} onClick={this.handleRecoverPayment} customType={type as string}>
            <FormattedMessage id={message} />
          </RecoverPaymentButton>
        )}
      </>
    );
  }
}
